export * from './osDetector';
